export const STATUS_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 403,
  INTERNAL_SERVER_ERROR: 500,
};
